import { idConfig } from '@glowforge/builder-components/lib/util/shared-configs';

/**
 * @type {import('@builder.io/sdk/dist/src/builder.class').Component}
 */
export default {
  name: 'magicSvg',
  friendlyName: 'Magic SVG',
  image: 'https://cdn.builder.io/api/v1/image/assets%2F69fac…a962e1cb3045ef%2Fac5a9d1ebe924e71b278c7cca6c8b804',
  inputs: [idConfig]
};
